import * as React from 'react';
import { useEffect } from 'react';
import { HeaderElements } from "../HeaderElements/HeaderElements";
import LoaderAnimation from "../Loader/LoaderAnimation";
import H1Header from "../WebmasterKit/H1Header";
import H1Text from "../WebmasterKit/H1Text";
import H2Header from "../WebmasterKit/H2Header";
import H2Text from "../WebmasterKit/H2Text";
import SeoFooter from "../WebmasterKit/SeoFooter";
import PhoneSexAdvertisements from "../Phonesex/PhoneSexAdvertisements";
import VXPaymentHint from "../Components/VXPaymentHint";
var Livecam = function () {
  var _a = React.useState([]),
    liveCamData = _a[0],
    setliveCamData = _a[1];
  var _b = React.useState(true),
    loading = _b[0],
    setLoading = _b[1];
  useEffect(function () {
    fetch('/rest/livecams').then(function (response) {
      return response.json();
    }).then(function (data) {
      return setliveCamData(data.data);
    }).then(function () {
      return setLoading(false);
    });
  }, []);
  var camMeta = window.layoutSettings.seo.extraSubPages.livecam.meta;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderElements, {
    canIndex: window.index.livecam,
    title: camMeta.title,
    description: camMeta.description
  }), /*#__PURE__*/React.createElement("div", {
    className: 'prodwidth center l-container h-center',
    id: "livecam"
  }, /*#__PURE__*/React.createElement(H1Header, {
    text: window.layoutSettings.seo.extraSubPages.livecam.h1.title
  }), /*#__PURE__*/React.createElement(H1Text, {
    text: window.layoutSettings.seo.extraSubPages.livecam.h1.text
  }), /*#__PURE__*/React.createElement(H2Header, {
    text: window.layoutSettings.seo.extraSubPages.livecam.h2.title
  }), /*#__PURE__*/React.createElement(H2Text, {
    text: window.layoutSettings.seo.extraSubPages.livecam.h2.text
  }), /*#__PURE__*/React.createElement(VXPaymentHint, null), loading && /*#__PURE__*/React.createElement(LoaderAnimation, null), /*#__PURE__*/React.createElement("div", {
    className: "livecam__grid"
  }, liveCamData.map(function (cam) {
    return /*#__PURE__*/React.createElement("div", {
      className: "livecam__item",
      key: cam.id
    }, /*#__PURE__*/React.createElement("a", {
      href: cam.linkVX + '?' + window.ladd,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      src: cam.avatar.url,
      alt: cam.name
    }), /*#__PURE__*/React.createElement("div", {
      className: "livecam__online"
    }, "Online"), /*#__PURE__*/React.createElement("div", {
      className: "livecam__name"
    }, cam.name)));
  })), /*#__PURE__*/React.createElement(PhoneSexAdvertisements, null), /*#__PURE__*/React.createElement(SeoFooter, {
    text: window.layoutSettings.seo.extraSubPages.livecam.footer.text
  })));
};
export default Livecam;